:host {
	display: flex;
	margin-top: 2em;
	margin-bottom: 10em;
}

:host>div {
	margin: auto;
	width: 1200px;
	max-width: calc(100% - 0.5rem);
}
